document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu
  var toggle = document.querySelector('.site-header__menu-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Open cart drawer on icon click
  var cartIcon = document.querySelector('.cart-icon');
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartIcon && cartDrawer) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.classList.add('is-open');
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) { renderCart(cart); });
    });
  }

  function renderCart(cart) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p>Your cart is empty.</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div style="display:flex;gap:12px;margin-bottom:16px;">' +
        '<img src="' + item.image + '" style="width:64px;height:80px;object-fit:cover;">' +
        '<div><div style="font-size:13px;text-transform:uppercase;">' + item.product_title + '</div>' +
        '<div style="font-size:12px;color:#777;">' + item.quantity + ' × $' + (item.price / 100).toFixed(2) + '</div></div>' +
        '</div>';
    });
    body.innerHTML = html;
  }

  // Click outside the nav closes it (mobile view)
  document.addEventListener('click', function (e) {
    if (nav && nav.classList.contains('is-open') && !nav.contains(e.target) && !toggle.contains(e.target)) {
      nav.classList.remove('is-open');
    }
  });
});
